import authApi from "../backendapi/authApi";
import { v4 as uuidV4 } from "uuid";
async function whoami() {
    return await authApi.whoami();
}

function isBrowser() {
    return typeof window !== "undefined" && typeof window.document !== "undefined";
}

function guestUid() {
    const roboflowUserId = window.user?.uid;

    if (roboflowUserId) return roboflowUserId;

    try {
        const parentRoboflowUserId = window.parent.user?.uid;

        if (parentRoboflowUserId) return parentRoboflowUserId;
    } catch (error) {
        // Do nothing
    }

    const analyticsAnonymousId = window?.analytics?.user?.().anonymousId?.();

    if (analyticsAnonymousId) return analyticsAnonymousId;

    return uuidV4();
}

function getReferer() {
    try {
        return window.location != window.parent.location
            ? document.referrer
            : document.location.href;
    } catch (e) {
        return window.location.href;
    }
}

function getGuestInfo() {
    if (!isBrowser()) throw new Error("Not running in a browser environment");

    const uid = guestUid();

    const data = {
        userAgent: window.navigator.userAgent,
        platform: window.navigator.platform,
        hostname: window.location.hostname,
        referer: getReferer()
    };

    if (uid) data.uid = uid;

    return data;
}

export async function refreshUserSession() {
    return await authApi.refreshUserSession();
}

export function currentUser() {
    return window.user;
}

export async function isRoboflowAdmin() {
    const { user } = await whoami();

    return !!user?.admin;
}

export async function setGuestRefreshToken() {
    const guestInfo = getGuestInfo();

    return await authApi.setGuestRefreshToken(guestInfo);
}

export async function setGuestAccessToken() {
    return await authApi.setGuestAccessToken();
}

export default {
    getGuestInfo,
    refreshUserSession,
    currentUser,
    setGuestRefreshToken,
    setGuestAccessToken,
    isRoboflowAdmin
};
